module.exports = __webpack_public_path__ + "static/media/mainChart2Descr1.bfe38b14.png";